import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { useSummaryStore } from '../../stores/summaryStore';
export var RefundTotal = function (_a) {
    var sessionValues = _a.sessionValues;
    var refundValues = useSummaryStore(function (state) { return state.refundValues; });
    var _b = refundValues || sessionValues || {}, subtotal = _b.subtotal, tax = _b.tax, total = _b.total;
    if (!subtotal || !total) {
        return null;
    }
    return (React.createElement("div", { className: "sui-flex sui-flex-col md:sui-max-w-sm sui-gap-1 sui-mt-4" },
        React.createElement("div", { className: "sui-flex sui-justify-between" },
            React.createElement(Typography, { weight: "bold" }, "Subtotal"),
            React.createElement(Typography, { weight: "bold" },
                "$",
                subtotal)),
        tax && (React.createElement("div", { className: "sui-flex sui-justify-between sui-mb-1" },
            React.createElement(Typography, null, "Tax"),
            React.createElement(Typography, null,
                "$",
                tax))),
        React.createElement("hr", null),
        React.createElement("div", { className: "sui-flex sui-justify-between sui-mt-1" },
            React.createElement(Typography, { weight: "bold" }, "Refund Total"),
            React.createElement(Typography, { weight: "bold" },
                "$",
                total))));
};
